"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BlueCheckbox = _interopRequireDefault(require("../CheckBox/BlueCheckbox"));

var _indeterminate_check_box = _interopRequireDefault(require("../../asset/icons/indeterminate_check_box.svg"));

var _check_box_outline = _interopRequireDefault(require("../../asset/icons/check_box_outline.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NestedCheckBox = function NestedCheckBox(_ref) {
  var dataArray = _ref.dataArray,
      updateList = _ref.updateList,
      title = _ref.title;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = (0, _react.useState)(_check_box_outline["default"]),
      _useState4 = _slicedToArray(_useState3, 2),
      svgPath = _useState4[0],
      setSvgPath = _useState4[1];

  var _useState5 = (0, _react.useState)('empty box'),
      _useState6 = _slicedToArray(_useState5, 2),
      altTag = _useState6[0],
      setAltTag = _useState6[1];

  var _useState7 = (0, _react.useState)(_toConsumableArray(dataArray)),
      _useState8 = _slicedToArray(_useState7, 2),
      checkboxChildren = _useState8[0],
      setCheckboxChildren = _useState8[1];

  (0, _react.useEffect)(function () {
    var newCount = Object.keys(checkboxChildren).filter(function (key) {
      return checkboxChildren[key].isChecked;
    }).length;
    setCount(newCount);
  }, [checkboxChildren]);
  (0, _react.useEffect)(function () {
    if (dataArray && dataArray.length) {
      setCheckboxChildren(_toConsumableArray(dataArray));
    }
  }, [setCheckboxChildren, dataArray]);
  (0, _react.useEffect)(function () {
    if (count > 0) {
      setSvgPath(_indeterminate_check_box["default"]);
      setAltTag('checked box');
    } else {
      setSvgPath(_check_box_outline["default"]);
      setAltTag('empty box');
    }
  }, [count]);

  var handleCheckChildElement = function handleCheckChildElement(index) {
    var copyOfChildren = _toConsumableArray(checkboxChildren);

    copyOfChildren[index].isChecked = !copyOfChildren[index].isChecked;
    setCheckboxChildren(copyOfChildren);
    updateList(copyOfChildren);
  };

  var handleAllChecked = function handleAllChecked(checkAllArg) {
    var copyOfChildren = _toConsumableArray(checkboxChildren).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isChecked: !checkAllArg
      });
    });

    setCheckboxChildren(copyOfChildren);
    updateList(copyOfChildren);
  };

  var handleSpaceBar = function handleSpaceBar(e) {
    if (e.key === ' ') {
      e.preventDefault();
      handleAllChecked(count > 0);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox df mb10",
    onClick: function onClick() {
      return handleAllChecked(count > 0);
    },
    onKeyPress: function onKeyPress(e) {
      return handleSpaceBar(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    tabIndex: "0",
    className: "curp",
    src: svgPath,
    alt: altTag
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    className: "dn",
    readOnly: true,
    checked: count > 0
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "ml15"
  }, title))), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "mt0 pl30 db df fxdrc"
  }, checkboxChildren.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_BlueCheckbox["default"], _extends({
      key: item.id,
      handleClick: function handleClick() {
        return handleCheckChildElement(index);
      }
    }, item));
  })));
};

var _default = NestedCheckBox;
exports["default"] = _default;